module.exports = __webpack_public_path__ + "media-placeholder.131bba2f075fb8f4d59606f8280a8156.svg";